import { AiChat } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { IconButton } from '@/components/icon-button/IconButton'
import { useStartMedSummaryAssetChat } from '../hooks/useStartMedSummaryAssetChat'

interface MedSummaryAssetChatButtonProps {
  assetId: string
  matterId: string
  /** Mobile top-bar presentation: plain icon sized for the bar rather than the outlined chip. */
  compact?: boolean
}

/**
 * Starts a conversation grounded in the matter's living Medical Billing Summary.
 */
export default function MedSummaryAssetChatButton(props: MedSummaryAssetChatButtonProps) {
  const { assetId, matterId, compact = false } = props
  const { isLoading, startChat } = useStartMedSummaryAssetChat({ assetId, matterId })

  if (compact) {
    return (
      <IconButton
        onClick={() => startChat()}
        disabled={isLoading}
        loading={isLoading}
        variant="plain"
        color="primary"
        size="lg"
        icon={<AiChat />}
        aria-label="Chat with the Medical Billing Summary"
      />
    )
  }

  return (
    <Button
      onClick={() => startChat()}
      disabled={isLoading}
      loading={isLoading}
      variant="outlined"
      color="primary"
      size="sm"
      leadingIcon={<AiChat />}
      aria-label="Chat with the Medical Billing Summary"
    >
      Ask Assistant
    </Button>
  )
}
